"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISMISSED = exports.DISCHARGED = void 0;
exports.DISCHARGED = "discharged";
exports.DISMISSED = "dismissed";